import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { useContext, useEffect, useRef, useState } from 'react'
import { AuthContext } from '../context/authProvider'
import { FORCE_OPEN_RADAR_MODAL_EVENT } from '../utils/constants'
import { EnvConfig } from '../config/EnvConfig'

export const useKambiWapi = () => {
  const [kambiWapiReady, setKambiWapiReady] = useState(false)
  const scriptRef = useRef(null)
  const { setTriggerGeolocation } = useContext(AuthContext)

  const isKambiWapiEnabled = useFeatureIsOn('fe_igp_kambi_wapi_enabled')
  const isKambiGeoModalEnabled = useFeatureIsOn(
    'fe_igp_kambi_geo_modal_enabled'
  )

  useEffect(() => {
    if (!isKambiWapiEnabled) return

    if (window?.KambiWidget) {
      setKambiWapiReady(true)
      return
    }

    if (!scriptRef.current) {
      const kambiWapiScript = document.createElement('script')
      kambiWapiScript.id = 'kambi-wapi-script'
      kambiWapiScript.src = EnvConfig.GATSBY_KAMBI_WIDGET_API
      kambiWapiScript.async = true
      kambiWapiScript.onload = () => setKambiWapiReady(true)

      document.body.appendChild(kambiWapiScript)
      scriptRef.current = kambiWapiScript
    }
  }, [isKambiWapiEnabled])

  useEffect(() => {
    if (!isKambiWapiEnabled) return
    if (!kambiWapiReady) return

    window?.KambiWidget?.ready?.then((wapi) => {
      wapi?.request(wapi?.BETSLIP_STAKE_UPDATED)

      wapi?.subscribe((res, wapi) => {
        if (res?.type === wapi?.BETSLIP_STAKE_UPDATED) {
          if (!isKambiGeoModalEnabled) return

          setTriggerGeolocation(true)
          const forceOpenRadarErrorModalEvent = new Event(
            FORCE_OPEN_RADAR_MODAL_EVENT
          )
          document.body.dispatchEvent(forceOpenRadarErrorModalEvent)
        }
      })
    })
  }, [kambiWapiReady, isKambiGeoModalEnabled, isKambiWapiEnabled])
}
